const getters = {
  token: state => state.user.token,
  nickname: state => state.user.nickname,
  navBar: state => state.app.navBar,
  navOpen: state => state.app.navOpen,
  navPath: state => state.app.path,
  navTitle: state => state.app.title,
  navIcon: state => state.app.icon,
  keepAliveList: state => state.aliveRouter.keepAliveList,
  visitedList: state => state.aliveRouter.visitedList,
  apps: state => state.system.apps,
}
export default getters
